const nav = (smoother) => {
  
  /***************************************************************
    HAMBURGER BUTTON
  ***************************************************************/

  const $body = $('body');
  const $burger = $('.site-hamburger button');
  const $mainNavA = $('.panel-menu a');
  const $mask = $('.panel-menu .mask');
  const $close = $('.main-panel-top .close');
  
  $($burger).add($mask).add($close).add($mainNavA).on('click', function () {
    if (!$body.hasClass('active')) {
      smoother.paused(true);
    } else {
      smoother.paused(false);
    }

    $('.panel-menu .active').removeClass('active');
    $('.active .sub-menu-wrapper').add('.sub-menu').attr('style', '');
    $body.toggleClass('active');
  });
    
  function checkWidth(x) {
    if (x.matches) { // If media query matches
      
      /***************************************************************
        DESKTOP MENU
      ***************************************************************/
		 
			/***************************************************************
				Unhover nav dropdown on click
			***************************************************************/

			const $subMenu = $('nav .sub-menu');
			const $subLinks = $('.submenu-item a');

			$subLinks.on('click', function() {
				$subMenu.fadeOut();
			});

     
      $('.sub-menu-wrapper').attr('style', '');
     
      const $subMenus = $('.menu-item-has-children');
      const $subClose = $('.sub-close');
      
      $subMenus.each(function() {

        const $this = $(this);
        const $subMenu = $this.find('.sub-menu-wrapper');
        
        $this.on('click', function(e) {

          e.preventDefault();
          
          if (e.target == this) {
            
            const $close = $('.panel-menu .close');
            const $previousLinks = $('.menu-item-has-children').not(this);
            const $previousMenus = $previousLinks.find('.sub-menu-wrapper.active');

            if ($previousMenus.length) {
              $previousMenus.css('z-index', '-2');
              $subMenu.add($this).add($close).addClass('active');
              setTimeout(() => {
                $previousMenus.add($previousLinks).removeClass('active');
                $previousMenus.css('z-index', '-1');
              }, 600);
            } else if ($subMenu.hasClass('active')) {
              $subMenu.add($this).add($close).removeClass('active');
            } else {
              $subMenu.add($this).add($close).addClass('active');
            }
          }
          
        });

      });
      
      $subClose.on('click', function() {
        $(this).parent().removeClass('active');
        $(this).parent().parent().removeClass('active');
        $('.panel-menu .close').removeClass('active');
        smoother.paused(false);
      });

    } else {
      
      /***************************************************************
        MOBILE MENU
      ***************************************************************/
     
      const $navDropBtn = $('.menu-item-has-children button');

      $navDropBtn.on('click', function() {
        const $this = $(this);
        const $subMenu = $this.parent().find('.sub-menu');
        const $subItems = $subMenu.find('ul');
				const $subHeaders = $subMenu.find('.sub-text-sm');
        $this.add($subMenu).toggleClass('active');
        $subMenu.slideToggle('fast', 'linear', function() {
          if ($subItems.hasClass('active')){
            $subItems.add($subHeaders).removeClass('active');
          } else {
            $subItems.add($subHeaders).addClass('active');
          }
        });

      });
      
      $mainNavA.on('click', function() {
        $('.sub-menu-wrapper').attr('style', '');
      });
      
    }

  }

  var x = window.matchMedia("(min-width: 62rem)")
  checkWidth(x)
  x.addListener(checkWidth)
    
}

export {
  nav
};
